import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { useUpdateOAuthState } from '../../OAuth/useUpdateOAuthState';

export const RipplingOauthCallback = () => {
  const { isLoading, postError } = useUpdateOAuthState();

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};
